import comp from "./TimezoneComp";
export default comp;
